const state = {
  devList: [],//设备列表
  resList: [],//分辨率列表
  photeResult:{
    imgPathStr:'',
    base64Str:'',
  },//拍照结果
  message:'',
  isDivce:true,//是否安装了高拍仪程序

};
const getters = {
  getIsDivce: state => {//获取设备列表
    return state.isDivce;
  },
  getDevList: state => {//获取设备列表
    return state.devList;
  },
  getResList: state => {//获取分辨率列表
    return state.resList;
  },
  getPhoteResult: state => {//获取拍照结果集
    return state.photeResult;
  },
  getMessage: state => {//获取提示信息
    return state.message;
  }
};
const mutations = {
  setIsDivce: (state, payload) => {
    state.isDivce = payload;
  },
  setDevList: (state, payload) => {
    state.devList = payload;
  },
  setResList: (state, payload) => {
    state.resList = payload;
  },
  setPhoteResult: (state, payload) => {
    state.photeResult = payload;
  },
  setMessage:(state, payload)=>{
    state.message = payload;
  }
};
const actions = {
  setIsDivce: (context, payload) => {
    context.commit("setIsDivce", payload);
  },
  setDevList: (context, payload) => {
    context.commit("setDevList", payload);
  },
  setResList: (context, payload) => {
    context.commit("setResList", payload);
  },
  setPhoteResult: (context, payload) => {
    context.commit("setPhoteResult", payload);
  },
  setMessage: (context, payload)=>{
    context.commit("setMessage", payload);
  }
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/vuex/modules/gpy.js